import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Breadcrumb from '../../components/Breadcrumb';

import { researchImages } from '../../data/images';

const [serviceImg, serviceImg2] = researchImages;

// Add a YouTube video id to show the play button on the middle picture.
const VIDEO_ID = null;

const areas = [
  'Environment System',
  'Geospatial Science',
  'Social Science and Development',
  'Management and Finance',
  'Landslide Studies',
  'Food Security',
];
const partners = [
  'Central Bank of Sri Lanka',
  'HARTI',
  'SANASA Life Insurance',
  'Multitech Solutions',
  'SANASA Development Bank',
  'SANASA Federation',
  'Janathakshan GTE',
  'Regional Science Association',
];

const ServiceDetailsMain = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <main>
      <Breadcrumb title="Research" subTitle="Research" />

      <div className="it-sv-details-area pt-120 pb-120">
        {VIDEO_ID && (
          <ModalVideo
            channel="youtube"
            isOpen={isOpen}
            videoId={VIDEO_ID}
            onClose={() => openModal()}
          />
        )}
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8">
              <div className="it-sv-details-top-wrap mb-50">
                <div className="row">
                  <div className="col-xl-6 col-lg-6">
                    <div className="it-sv-details-top-thumb">
                      <img src={serviceImg} alt="" />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6">
                    <div className="it-sv-details-top-content">
                      <h4 className="it-sv-details-title">Research</h4>
                      <p>
                        The HEI-SL Cell is the campus's research and
                        business-links office. It began as the Research and
                        Business Cell on 8 September 2016, and became the
                        HEI-SL Cell in 2019. It follows University Grants
                        Commission Circular No. 10/2016.
                      </p>
                      <p>
                        Its job: find research that can earn money, link
                        researchers with businesses, turn results into
                        products, and teach how to protect ideas.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="it-sv-details-top-content mb-50">
                    <h4 className="it-sv-details-title">Research Projects</h4>
                    <p>
                      Landslide Risk Index for Sri Lanka: a development
                      research project funded by the AHEAD grant, a World
                      Bank-funded programme run by the Ministry of Higher
                      Education.
                    </p>
                    <p>
                      SANASA "Govi Sangramaya" Agriculture Scheme: a plan to
                      grow organic food in home gardens. The first stage reaches
                      1,500 members from 100 primary societies in Kegalle
                      District.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="it-sv-details-content-box mb-50">
                    <h5 className="it-sv-details-title-sm">
                      <span>
                        <i className="fa-sharp fa-light fa-check"></i>
                      </span>
                      Research Areas
                    </h5>
                    <p>
                      Environment System; Geospatial Science; Social Science
                      and Development; Management and Finance.
                    </p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="it-sv-details-content-box mb-50">
                    <h5 className="it-sv-details-title-sm">
                      <span>
                        <i className="fa-sharp fa-light fa-check"></i>
                      </span>
                      Who Works On It
                    </h5>
                    <p>
                      A research team of six, guided by an advisory board of
                      eleven members.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="it-sv-details-top-content">
                    <h4 className="it-sv-details-title">Other Studies</h4>
                    <p className="mb-30">
                      Study on Landslides in Kegalle District: why landslides
                      happen, their effects, how recovery goes and how
                      vulnerable communities are resettled.
                    </p>
                    <div className="it-sv-details-middle-thumb p-relative mb-30">
                      <img src={serviceImg2} alt="" />
                      {VIDEO_ID && (
                        <Link
                          className="popup-video it-pulse"
                          to="#"
                          onClick={openModal}
                        >
                          <i className="fa-sharp fa-solid fa-play"></i>
                        </Link>
                      )}
                    </div>
                    <p>
                      Study on resettlement and development on the
                      Moragahakanda-Kaluganga water project: a field study of
                      resettlement and development policy.
                    </p>
                    <p>
                      In 2023 the cell led a field survey in Mawenella,
                      Rambukkana and Aranayake to find landslide spots and
                      collect data for the PLI App.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4">
              <div className="it-sv-details-sidebar">
                <div className="it-sv-details-sidebar-search mb-55">
                  <input type="text" placeholder="search" />
                  <button type="submit">
                    <i className="fal fa-search"></i>
                  </button>
                </div>
                <div className="it-sv-details-sidebar-widget mb-45">
                  <h4 className="it-sv-details-sidebar-title mb-30">
                    Research Areas
                  </h4>
                  {areas.map((area, i) => (
                    <div
                      key={area}
                      className={
                        i === 1
                          ? 'it-sv-details-sidebar-category active mb-10'
                          : 'it-sv-details-sidebar-category mb-10'
                      }
                    >
                      {area}
                      <span>
                        <i className="fa-light fa-angle-right"></i>
                      </span>
                    </div>
                  ))}
                </div>
                <div className="it-sv-details-sidebar-widget">
                  <h4 className="it-sv-details-sidebar-title mb-30">
                    Partners:
                  </h4>
                  <div className="sidebar__widget-content">
                    <div className="tagcloud">
                      {partners.map((partner) => (
                        <a key={partner} href="#">
                          {partner}
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default ServiceDetailsMain;
